import { post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ExistingAddAccountModel, NewAddAccountModel } from "@theHescoBlueprint/ApiModels";

const existingAddAccountUrl = "/api/v2/createaccountcustom/existing";

const newAddAccountUrl = "/api/v2/createaccountcustom/new";

export async function addAccountExistingCustomer(
    parameter: ExistingAddAccountModel,
): Promise<ServiceResult<ExistingAddAccountModel>> {
    try {
        const addExistingAccountModel = await post(`${existingAddAccountUrl}`, parameter);
        return {
            successful: true,
            result: addExistingAccountModel,
        };
    } catch (error) {
        if (error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export function addAccountNewCustomer(parameter: NewAddAccountModel) {
    const formData = new FormData();
    formData.append("newaccountrequest", JSON.stringify(parameter.newaccountrequest));

    if (parameter?.attachment?.attachment !== null) {
        formData.append("attachment", parameter.attachment.attachment);
    }

    return request<NewAddAccountModel>(newAddAccountUrl, "POST", {}, formData);
}
